module.exports = __webpack_public_path__ + "static/media/test-logs.14430953.svg";